/* Skeleton — pulsing placeholder for loading rows. */
import React from "react";
import { P } from "../../shared/constants";
var E = React.createElement;

export default function Skeleton(props){
  var rows = props.rows || 5;
  var height = props.height || 14;
  var arr = [];
  for(var i=0;i<rows;i++){
    arr.push(E("div",{key:i,"aria-hidden":"true",
      style:{height:height,borderRadius:6,background:P.bgS,
        marginBottom:8,opacity:.6,animation:"pulse 1.4s ease-in-out infinite"}}));
  }
  return E("div",{role:"status","aria-live":"polite","aria-busy":"true",
    style:{padding:8}},
    arr,
    E("span",{style:{position:"absolute",width:1,height:1,padding:0,
      margin:-1,overflow:"hidden",clip:"rect(0,0,0,0)",whiteSpace:"nowrap",border:0}},
      props.label || "Loading…")
  );
}
